module.exports = __webpack_public_path__ + "static/img/background-1.c131e0b7.png";